var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkwellLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2018.02 512.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M224.2,10.55C107.42,10.55,12.76,105.22,12.76,222c0,108.68,82,198.11,187.53,210v43.75c0,23.58,28.45,35.44,45.2,18.85l99.09-98.19c.42-.42.56-1,.95-1.41,54.43-38.26,90.1-101.41,90.1-173C435.63,105.22,341,10.55,224.2,10.55Zm0,346.59c-64.19,0-116.41-48.18-116.41-107.4a21.85,21.85,0,0,1,43.69,0c0,35.12,32.62,63.71,72.72,63.71s72.72-28.59,72.72-63.71a21.85,21.85,0,0,1,43.69,0C340.61,309,288.38,357.14,224.2,357.14Z",
    style: {
      fill: "#ffae9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.06,59.26c0,1.85-1.56,3.78-4.38,3.78H1934.9l.07,35.65c0,2.67-2.44,3.93-4.37,3.93s-4.3-1.26-4.3-3.93V63h-13.71c-2.9,0-4.16-1.93-4.16-3.78a3.78,3.78,0,0,1,4.16-3.86h36.09C1951.5,55.4,1953.06,57.33,1953.06,59.26Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.62,57.63l15.49,24.24,15.42-24.32a4.69,4.69,0,0,1,3.93-2.15,4,4,0,0,1,4.15,4.15V98.77c0,2.59-2.3,3.85-4.37,3.85s-4.23-1.26-4.23-3.85v-25l-11,17.27a4.33,4.33,0,0,1-3.86,2.15,4.76,4.76,0,0,1-4-2.37l-10.9-17V98.77c0,2.59-2.22,3.85-4.3,3.85s-4.3-1.26-4.3-3.85V59.63a4.18,4.18,0,0,1,4.23-4.23A4.61,4.61,0,0,1,1964.62,57.63Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.84,278.36c24.92-22.47,53.51,8.58,30.63,30.23-19.19,18.38-47,24.91-73.93,24.51C546.41,333.1,502.7,291,502.7,229.75,502.7,162.76,544,117,609.32,117s102.12,42.89,102.52,106.2c0,13.49-2.45,24.51-25.73,24.51h-136c7.35,26.56,30.22,44.94,59.23,44.94C624.84,292.66,640.77,288.57,653.84,278.36Zm-104.16-67H668.54c-2.85-32.27-20.42-53.92-58.82-53.92C577.86,157.45,555.4,179.1,549.68,211.37Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.12,85.15v223c0,13.07-8.58,20.83-23.69,20.83-14.71,0-21.65-7.35-22.06-19.61-17.57,15.53-40.85,23.29-60.46,23.29-61.27,0-98.85-44.94-98.85-109.88,0-61.68,40.44-105.8,100.49-105.8,18,0,40,6.95,58,21.24V85.15c0-14.3,11.44-20.42,22.88-20.42S947.12,70.85,947.12,85.15ZM901.37,255.48l-.41-62.9c-9.39-22.06-32.68-34.31-55.14-34.31-34.32,0-57.19,27.77-57.19,64.94,0,40,21.24,68.22,53.51,68.22C869.1,291.43,893.61,278.77,901.37,255.48Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193,144V308.18c0,13.48-12.26,20.83-23.29,20.83-11.84,0-23.28-7.35-23.28-21.24v-1.63c-22.46,21.65-47.38,27-68.21,27-56.78,0-89.87-38.4-89.87-99.26V144c0-12.66,8.58-22.87,23.28-22.87,13.89,0,23.29,10.21,23.29,22.87v90.68c0,35.54,15.52,57.6,50.24,57.6,20.83,0,61.27-22.47,61.27-70.26V144c0-13.07,7.76-22.87,22.88-22.87C1183.62,121.1,1193,130.9,1193,144Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.15,315.53c0,9-7.36,13.48-14.71,13.48-7.76,0-15.11-4.49-15.11-13.48V150.91h-22.06c-15.93,0-15.52-24.91.41-24.91h21.65V115c0-36.36,30.23-58.82,61.68-58.82a61.53,61.53,0,0,1,38.4,13.07c14.29,12.25-4.5,31.45-16.75,20.83a29.56,29.56,0,0,0-20-7.35c-16.34,0-33.49,11-33.49,32.68V126h39.21c14.71,0,14.71,24.91,0,24.91h-39.21Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.22,243.23H1378.87c5.31,33.5,33.9,62.5,74.75,62.5,18.79,0,38.4-4.9,54.33-17.16,14.3-13.07,35.54,3.68,19.61,20-18.79,17.56-46.16,24.91-72.71,24.51-64.54,0-106.21-46.57-106.21-108.25,0-69,51.88-106.61,104.16-106.61,55.15,0,106.21,32.27,107.43,106.2C1560.23,233.43,1557,243.23,1540.22,243.23Zm-8.58-24.92c-4.08-49-42.48-72.3-76.79-72.3-38.4,0-73.53,23.29-77.21,72.3Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.8,243.23H1619.46c5.31,33.5,33.9,62.5,74.75,62.5,18.79,0,38.4-4.9,54.33-17.16,14.29-13.07,35.53,3.68,19.6,20-18.79,17.56-46.16,24.91-72.71,24.51-64.54,0-106.2-46.57-106.2-108.25,0-69,51.88-106.61,104.16-106.61,55.15,0,106.21,32.27,107.43,106.2C1800.82,233.43,1797.55,243.23,1780.8,243.23Zm-8.57-24.92c-4.09-49-42.48-72.3-76.8-72.3-38.39,0-73.52,23.29-77.2,72.3Z",
    style: {
      fill: "#264254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.69,329c-9,0-15.11-6.13-15.11-13.89V70c0-7.76,6.12-13.89,15.11-13.89,8.17,0,14.7,6.13,14.7,13.89V315.12C1867.39,322.88,1860.86,329,1852.69,329Z",
    style: {
      fill: "#264254"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkwellLogo);
export default __webpack_public_path__ + "static/media/workwell-logo.92aca73f017fd71e0c9c5f238af6b7e7.svg";
export { ForwardRef as ReactComponent };